import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import DonationSettings from './DonationSettings';
import LoyaltySettings from './LoyaltySettings';
import OrderRecoverySettings from './OrderRecoverySettings';
import RatedOrdersSettings from './RatedOrdersSettings';
import ReferralSettings from './ReferralSettings';
import SettingsLayout from './SettingsLayout';

const Settings = ({ match }) => (
  <div className="dashboard-wrapper">
    <SettingsLayout match={match}>
      <Switch>
        <Redirect exact from={`${match.url}`} to={`${match.url}/order-recovery`} />
        <Route path={`${match.url}/order-recovery`} component={OrderRecoverySettings} />
        <Route path={`${match.url}/loyalty`} component={LoyaltySettings} />
        <Route path={`${match.url}/referral`} component={ReferralSettings} />
        <Route path={`${match.url}/donations`} component={DonationSettings} />
        <Route path={`${match.url}/rated-orders`} component={RatedOrdersSettings} />
        <Redirect to="/error" />
      </Switch>
    </SettingsLayout>
  </div>
);

export default Settings;
